module.exports = __webpack_public_path__ + "img/7_of_Spades.svg.ed0e4099.png";